import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=0348a2a1&scoped=true&"
import script from "./ProjectDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectDetails.vue?vue&type=style&index=1&id=0348a2a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348a2a1",
  null
  
)

export default component.exports